import Typography from '@mui/material/Typography'
import { ConfirmDialogWrapper } from '../../components/ConfirmDialogWrapper'
import { useAssistantAdministrationStore } from '../../store/storeAssistantAdministration'
import { useWrapperStore } from '../../store/storeWrapper'

export const ProjectArchiveDialog = ({ open, handleClose, workplaceDetail }) => {
    const { archiveWorkplace, isLoadingArchiveWorkplace } = useAssistantAdministrationStore(
        (state) => state,
    )
    const { fetchProjectList } = useWrapperStore((state) => state)

    const handleClickArchive = async () => {
        await archiveWorkplace(
            { workplaceId: workplaceDetail.id },
            { is_archived: !workplaceDetail.is_archived },
        )
        await fetchProjectList()

        if (!workplaceDetail.is_archived) {
            window.open(`/project/archive`, '_self')
        } else {
            window.open(`/project/?workplaceId=${workplaceDetail.id}&&is_archived=false`, '_self')
        }
    }

    return (
        <>
            <ConfirmDialogWrapper
                open={open}
                handleSubmit={handleClickArchive}
                handleClose={handleClose}
                title={
                    workplaceDetail.is_archived
                        ? 'Вернуть проект  из архива?'
                        : 'Архивировать проект?'
                }
                submitButtonText={workplaceDetail.is_archived ? 'Разархивировать' : 'Архивировать'}
                isDisabled={isLoadingArchiveWorkplace}>
                {workplaceDetail.is_archived ? (
                    <> Проект будет восстановлен. </>
                ) : (
                    <Typography variant="body1">
                        Проект и его содержимое, а именно: записи и запросы будут перенесены в Архив
                        проектов. Вы сможете восстановить его в любое время
                    </Typography>
                )}
            </ConfirmDialogWrapper>
        </>
    )
}
